export default __webpack_public_path__ + "static/media/appStoreIconNew.2a11282e.webp";